import { useEffect, useState, useRef } from 'react';

// mui
import { Fade, Box, Stack } from '@mui/material';

// icons
import { VolumeOff as VolumeOffIcon, VolumeUp as VolumeUpIcon } from '@mui/icons-material';

// components
import { PostShowMediaDialog } from '..';

// client-shared
import { storage } from '@goldblack/client-storage';
import { path } from '@goldblack/client-utils';

function PostShowMediaPlay(props) {
    const internal = storage.transience.getValue('internal');
    const [fadeIn, setFadeIn] = useState(0);
    const mediaTypeRef = useRef('');

    const onCloseImage = () => {
        props.onClose();
    };

    const onFadeEnd = () => {
        if (fadeIn === 1) {
            setTimeout(() => {
                setFadeIn(2);
            }, 1000);
        }
    };

    const getClickSide = (e) => {
        let bounds = e.target.getBoundingClientRect();
        let offsety = e.clientY - bounds.top;
        let height = e.target.clientHeight;
        return height / 2 > offsety ? 0 : 1; // 0=up, 1=bottom
    };

    const onClick = (e) => {
        const changeMute = () => {
            let current = internal.mute;
            storage.transience.setState('internal.mute', !current);
            setFadeIn(1);
            props.onMuteChange?.(!current);
        };

        let side = getClickSide(e);
        switch (mediaTypeRef.current) {
            case 'image/jpeg':
            case 'image/png':
                if (props.dialog) {
                    onCloseImage();
                }
                break;
            case 'video/mp4':
                if (props.dialog) {
                    if (side === 0) {
                        onCloseImage();
                    } else if (side === 1) {
                        changeMute();
                    }
                } else {
                    changeMute();
                }
                break;
            default:
                break;
        }
    };

    const ShowSoundIcon = () => {
        return (
            <Fade in={fadeIn === 1 ? true : fadeIn === 2 ? false : undefined} addEndListener={onFadeEnd}>
                <Stack
                    direction='row'
                    justifyContent='center'
                    alignItems='center'
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        background: '#0000007f',
                        width: '50px',
                        height: '50px',
                        borderRadius: '10px',
                    }}>
                    {internal.mute ? (
                        <VolumeOffIcon sx={{ m: 1, color: '#ffffff' }} />
                    ) : (
                        <VolumeUpIcon sx={{ m: 1, color: '#ffffff' }} />
                    )}
                </Stack>
            </Fade>
        );
    };

    useEffect(() => {
        mediaTypeRef.current = path.getContentType(props.post.image);
    }, []);

    return (
        <Box onClick={onClick} sx={{ userSelect: 'none', overflow: 'hidden' }}>
            {PostShowMediaDialog(
                props.post,
                props.muted || internal.mute,
                null,
                null,
                props.blurred,
                props.showThumbnail,
            )}
            {ShowSoundIcon()}
        </Box>
    );
}

export { PostShowMediaPlay };
